import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Table, Modal, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiEdit2, FiTrash2, FiPlus } from "react-icons/fi";
import {
  API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST,
  API_COUNTRY_CODE_DIRECTIONS_MASTER_DELETE,
} from "../../../service/url";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { ROUTES, USER_ROLES } from "../../../utilities/constant";
import { Storage } from "../../../utilities/setting";

const CountryCodeDirectionsList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    try {
      const user = JSON.parse(Storage.getItem("user"));
      setIsSuperAdmin(user?.role === USER_ROLES.SUPERADMIN);
    } catch (_) {}
    loadList();
  }, []);

  const loadList = () => {
    setLoading(true);
    getApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_LIST, {})
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch((err) =>
        toast.error(typeof err === "string" ? err : JSON.stringify(err)),
      )
      .finally(() => setLoading(false));
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!selectedId) return;

    postApiCall(API_COUNTRY_CODE_DIRECTIONS_MASTER_DELETE(selectedId), {})
      .then(() => {
        toast.success("Deleted");
        loadList();
        setShowDeleteModal(false);
        setSelectedId(null);
      })
      .catch((err) =>
        toast.error(typeof err === "string" ? err : JSON.stringify(err)),
      );
  };

  return (
    <Row>
      <Col xl="12">
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Country Codes</h4>
            {isSuperAdmin && (
              <Button
                variant="primary"
                onClick={() =>
                  navigate(`/${ROUTES.COUNTRY_CODE_DIRECTIONS.CREATE}`)
                }
              >
                <FiPlus /> Add New
              </Button>
            )}
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Country</th>
                  <th>Calling Code</th>
                  <th>Status</th>
                  {isSuperAdmin && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={5}>Loading...</td>
                  </tr>
                )}
                {!loading && rows.length === 0 && (
                  <tr>
                    <td colSpan={5}>No records</td>
                  </tr>
                )}
                {!loading &&
                  rows.map((r, idx) => (
                    <tr key={r.id}>
                      <td>{idx + 1}</td>
                      <td>{r.country_code?.name || "-"}</td>
                      <td>
                        {r.country_code?.calling_code
                          ? `+${r.country_code.calling_code}`
                          : "-"}
                      </td>
                      <td>
                        <Badge bg={r.is_enabled ? "success" : "secondary"}>
                          {r.is_enabled ? "Enabled" : "Disabled"}
                        </Badge>
                      </td>
                      {isSuperAdmin && (
                        <td>
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() =>
                              navigate(
                                `/${ROUTES.COUNTRY_CODE_DIRECTIONS.EDIT.replace(
                                  ":id",
                                  r.id,
                                )}`,
                              )
                            }
                            className="me-2"
                          >
                            <FiEdit2 />
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => handleDelete(r.id)}
                          >
                            <FiTrash2 />
                          </Button>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
      <Modal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setSelectedId(null);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete this country code?
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowDeleteModal(false);
              setSelectedId(null);
            }}
          >
            Cancel
          </Button>

          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Row>
  );
};

export default CountryCodeDirectionsList;
